import React from "react";
import "./FAQColumn.css";

function FAQColumn() {
  return (
    <div className="faqcolumn">
      <h1>Freqently Asked Questions</h1>
      <h4>Still need help? Reach out to Steph</h4>
      {/* ADD BUTTON TO EMAIL HERE */}
    </div>
  );
}

export default FAQColumn;
